import { render, staticRenderFns } from "./ShowEmail.vue?vue&type=template&id=a0fd366e"
import script from "./ShowEmail.vue?vue&type=script&lang=js"
export * from "./ShowEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports